<template>
  <div class="community-header">
    <div class="container">
      <div class="row align-items-center">
        <div class="col-md-8">
          <h1 class="page-title">
            <i class="bi bi-people-fill me-3"></i>Health Community
          </h1>
          <p class="page-subtitle">Share health insights, exchange life experiences, grow together</p>
        </div>
        <div class="col-md-4 text-end">
          <button
            v-if="isAuthenticated"
            class="btn btn-primary btn-lg me-2"
            @click="$emit('create-post')"
          >
            <i class="bi bi-plus-circle me-2"></i>Share Post
          </button>
          <!-- Demo Data Button (for development) -->
          <button
            v-if="isAuthenticated && isAdmin"
            class="btn btn-outline-secondary"
            @click="$emit('seed-data')"
            :disabled="seeding"
          >
            <span v-if="seeding" class="spinner-border spinner-border-sm me-2"></span>
            <i v-else class="bi bi-database me-2"></i>
            {{ seeding ? 'Seeding...' : 'Add Demo Data' }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CommunityHeader',
  props: {
    isAuthenticated: {
      type: Boolean,
      required: true
    },
    isAdmin: {
      type: Boolean,
      default: false
    },
    seeding: {
      type: Boolean,
      default: false
    }
  },
  emits: ['create-post', 'seed-data']
}
</script>

<style scoped>
.community-header {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 3rem 0;
}

.page-title {
  font-size: 2.5rem;
  font-weight: bold;
  margin-bottom: 0.5rem;
}

.page-subtitle {
  font-size: 1.1rem;
  opacity: 0.9;
  margin: 0;
}

@media (max-width: 768px) {
  .community-header {
    padding: 2rem 0;
  }

  .page-title {
    font-size: 2rem;
  }
}
</style>
